import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import 'antd/dist/antd.css'
import { colors } from 'constants/theme'
import * as UseStyled from 'features/setting/personnel-managements/personnels/useStyles'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

/** UTILS || SLICE */
import { editDocument, selectLoadingDocument, selelctDocument } from 'app/slice/user.slice'

//COMPONENT
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { fileUrl } from 'api/api'
import { notiError } from 'component/notifications/notifications'
import UploadImage from 'component/Upload/UploadImage'
import { useEffect, useMemo, useRef, useState } from 'react'
import CanvasDraw from 'react-canvas-draw'
import { useWacomPenInput } from 'services/wacom/useWacomPenInput'
import WacomStatusChip from 'services/wacom/WacomStatusChip'

interface UserAttachmentsInterface {
  userAttachmentId: number | null
  attachmentType: string
  fileId: number
  base64: string
  type: string
  fileExtension: string
  fileSize: string
}
interface DocumentProps {
  isEdit: boolean
  attachment?: any
}

export default function Document(props: DocumentProps) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const loading = useSelector(selectLoadingDocument)

  const userDoc = useSelector(selelctDocument)
  const [tabSignature, setTabSignature] = useState('DRAW')
  const canvasRef: any = useRef()

  const [signatureAttachments, setSignatureAttachments] = useState<any>({})
  const [uploadSignatureAttachments, setUploadSignatureAttachments] = useState<any>({})
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [userAttachments, setUserAttachments] = useState<UserAttachmentsInterface[]>([])
  const ID_CARD = {
    userAttachmentId: null,
    attachmentType: 'ID_CARD',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const HOUSE_REGISTRATION = {
    userAttachmentId: null,
    attachmentType: 'HOUSE_REGISTRATION',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const DENTIST_LICENSE = {
    userAttachmentId: null,
    attachmentType: 'DENTIST_LICENSE',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const DENTAL_COUNCIL_BOOK = {
    userAttachmentId: null,
    attachmentType: 'DENTAL_COUNCIL_BOOK',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const TRETMENT_FEE_SHEET = {
    userAttachmentId: null,
    attachmentType: 'TRETMENT_FEE_SHEET',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const DOCTOR_SCHEDULE = {
    userAttachmentId: null,
    attachmentType: 'DOCTOR_SCHEDULE',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const OPERATING_SYSTEM = {
    userAttachmentId: null,
    attachmentType: 'OPERATING_SYSTEM',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const PROMOTION = {
    userAttachmentId: null,
    attachmentType: 'PROMOTION',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }
  const IMAGE = {
    userAttachmentId: null,
    attachmentType: 'IMAGE',
    fileId: userAttachments.length,
    base64: 'string',
    type: 'string',
    fileExtension: 'string',
    fileSize: 'string'
  }

  useEffect(() => {
    if (!loading) {
      if (props.isEdit) {
        setUserAttachments(userDoc.userAttachments)
        setSignatureAttachments(userDoc.signatureAttachments)
      }
    }
  }, [loading])

  const setAttachments = (url: string) => {
    const isJpgFile = /\/([^/?]+)\.jpg($|\?)/i.test(url);
    return isJpgFile
  }
  const setAttachments_cache = useMemo(() => setAttachments(signatureAttachments.filePath), [signatureAttachments]);

  async function FiletoBase64(event: any) {
    const blob = event.target.files[0]
    const reader = new FileReader()
    try {
      await new Promise((resolve) => {
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
      return reader.result
    } catch (error) {
      return
    }
  }

  const addDocument = async (event: any, fileId: any, objType: any) => {
    if (event.target.files != null) {
      const file = event.target.files[0]
      const fileName = file.name.split('.')

      try {
        const name = event.target.files[0].name
        await FiletoBase64(event).then((base64) => {
          let base64string: any = `${base64}`.split(',')

          base64string = base64string[base64string.length - 1]

          dispatch(
            editDocument({
              value: [...userAttachments, { ...objType, fileId: fileId, type: name, fileExtension: fileName[fileName.length - 1], fileSize: file.size.toString(), base64: base64string }],
              key: 'userAttachments'
            })
          )
          setUserAttachments([...userAttachments, { ...objType, fileId: fileId, type: name, fileExtension: fileName[fileName.length - 1], fileSize: file.size.toString(), base64: base64string }]) //can't set base 64
        })
      } catch (error) {
        return
      }
    }
  }

  const hendlerDelete = (clickId: any) => {
    if (fileInputRef.current) { fileInputRef.current.value = ""; }
    const user: any = userAttachments.filter(({ fileId }: any, index: any) => fileId !== clickId)
    setUserAttachments(user)
    dispatch(editDocument({ value: user, key: 'userAttachments' }))
  }

  const openImgOnInsert = (img: any) => {
    if (img.fileExtension === "pdf") {
      const w = window.open('_blank');
      if (w) {
        w.document.write('<body style="margin: 0px"></body>')
        w.document.write(
          `<div style="background-color:black;text-align:center;height:100%;width:100%">
                <iframe style="min-height:100vh;width:100%" frameborder="0" src=${"data:application/pdf;base64," + img.base64}></iframe>
            </div>`
        )
      }
    }
    if (img.fileExtension !== "pdf") {
      const w = window.open('_blank');
      if (w) {
        w.document.write('<body style="margin: 0px"></body>')
        w.document.write(
          `<div style="background-color:black;text-align:center;height:100%;width:100%">
                <img style="display:block; margin:auto; height:100%;" src=${"data:image/png;base64," + img.base64}></img>
                </div>`
        )
      }
    }
  }


  const renderFileUploadAndPreview = (title: string, option: string) => {
    let addObj: any = ID_CARD
    if (option === 'ID_CARD') addObj = ID_CARD
    if (option === 'HOUSE_REGISTRATION') addObj = HOUSE_REGISTRATION
    if (option === 'DENTIST_LICENSE') addObj = DENTIST_LICENSE
    if (option === 'DENTAL_COUNCIL_BOOK') addObj = DENTAL_COUNCIL_BOOK
    if (option === 'TRETMENT_FEE_SHEET') addObj = TRETMENT_FEE_SHEET
    if (option === 'DOCTOR_SCHEDULE') addObj = DOCTOR_SCHEDULE
    if (option === 'OPERATING_SYSTEM') addObj = OPERATING_SYSTEM
    if (option === 'PROMOTION') addObj = PROMOTION
    if (option === 'IMAGE') addObj = IMAGE
    return (
      <Box sx={{ mx: 0, mt: 2, py: 1 }}>
        <Typography sx={{ mb: 1, pl: 0 }}>
          {t(title)}
        </Typography>
        <Grid container>
          <Grid item xs={12}>
            {userAttachments
              .filter(att => att.attachmentType === option)
              .map(obj => {
                const fileEntry = _.find(props.attachment, att => att.file?.fileId === obj.fileId)?.file || {}
                const hasFile = fileEntry.filePath && fileEntry.fileName
                const displayName = hasFile ? hasFile.split('?')[0] : obj.type;
                return (
                  <Box key={obj.fileId} sx={{ width: '100%', mb: 1 }}>
                    <Grid container alignItems="center" spacing={1}>
                      {/* File link */}
                      <Grid item>
                        <Box
                          component="label"
                          htmlFor={`contained-button-file-${obj.fileId}`}
                          onClick={() => {
                            if (hasFile) {
                              window.open(`${fileUrl}/${fileEntry.filePath}/${fileEntry.fileName}`)
                            } else {
                              openImgOnInsert(obj)
                            }
                          }}
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            pr: 1,
                            mr: 1,
                            maxWidth: 300,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            cursor: hasFile ? 'pointer' : 'default',
                            color: 'text.primary'
                          }}
                        >
                          <AttachFileIcon
                            sx={{
                              transform: 'rotate(45deg)',
                              fontSize: 22,
                              mr: 0.5
                            }}
                          />
                          {displayName || 'document'}
                        </Box>
                      </Grid>
                      {/* Delete button */}
                      {/* <Grid item>
                        <ButtonDeleteReg onClick={() => hendlerDelete(obj.fileId)} />
                      </Grid> */}
                    </Grid>
                  </Box>
                )
              })}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <input
              accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
              id={`contained-button-file-${option}`}
              multiple
              type="file"
              style={{ display: 'none' }}
              onChange={e => addDocument(e, addObj.fileId, addObj)}
              ref={fileInputRef}
            />
            <Box component="label" htmlFor={`contained-button-file-${option}`}>
              <UseStyled.DivAdd
                sx={{
                  mt: 2,
                  ml: 2,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: colors.themeSecondColor80 }
                }}
              >
                + {t('PERSONNEL.DOCUMENT.ADD_DOCUMENT')}
              </UseStyled.DivAdd>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
      </Box>
    )
  }

  const renderCanvas = () => {
    if (canvasRef.current) {
      const base64 = canvasRef.current.canvasContainer.childNodes[1].toDataURL('image/jpg')
      let base64string: any = `${base64}`.split(',')

      base64string = base64string[base64string.length - 1]
      const val: any = { ...signatureAttachments, base64: base64string, fileExtension: 'jpg', fileSize: '0', type: 'signature' }

      setSignatureAttachments({ ...signatureAttachments, base64: base64, fileExtension: 'jpg', fileSize: '0', type: 'signature' })
      dispatch(editDocument({ value: val, key: 'signatureAttachments' }))
    }
  }

  const wacom = useWacomPenInput<'signature'>({
    canvases: { signature: canvasRef },
    active: 'signature',
    onStrokeCommit: () => renderCanvas(),
  })

  const clearCanvas = () => {
    setSignatureAttachments({
      fileId: null,
      base64: '',
      fileExtension: 'jpg',
      fileSize: '0',
      type: 'signature',
    })
    dispatch(editDocument({
      value: {
        fileId: null,
        base64: '',
        type: 'signature',
        fileExtension: '',
        fileSize: '',
        filePath: ''
      }, key: 'signatureAttachments'
    }))
    if (canvasRef.current) {
      canvasRef.current.clear()
      canvasRef.current.imgSrc = ''
      canvasRef.current.resetView()
    }
    wacom.clearPad()
  }

  const uploadNewsImageSign = (files: any) => {
    if (files[0]) {
      const checkFileName = ["jpg", "png"];
      const file = files[0]
      const fileName = file.name.split('.')
      if (file.size < 2 * 1024 * 1024 && checkFileName.includes(fileName[fileName.length - 1])) {
        const detailImage = {
          fileId: signatureAttachments?.fileId || null,
          base64: '',
          type: 'signature',
          fileExtension: fileName[fileName.length - 1],
          fileSize: file.size.toString(),
        }
        const reader: any = new FileReader()
        reader.addEventListener('load', () => {
          /** reader.result is base64 */
          const base64 = reader.result.split(',')
          setUploadSignatureAttachments({ ...uploadSignatureAttachments, base64: reader.result })
          detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
          dispatch(editDocument({ value: detailImage, key: 'signatureAttachments' }))
        })
        reader.readAsDataURL(file)
        setUploadSignatureAttachments({ ...uploadSignatureAttachments, fileExtension: detailImage.fileExtension, fileSize: detailImage.fileSize, type: 'signature' })
      } else {
        notiError(t('USER.ALERT.FILE_SUPPORT'))
      }

    }
  }

  const clearUploadSign = () => {
    clearCanvas()
    setUploadSignatureAttachments({ fileId: null, base64: '', fileExtension: '', fileSize: '', type: 'signature', filePath: '' })
    dispatch(editDocument({
      value: {
        fileId: null,
        base64: '',
        type: 'signature',
        fileExtension: '',
        fileSize: '',
        filePath: ''
      }, key: 'signatureAttachments'
    }))
  }

  return (
    <Box sx={{ p: 3, width: '100%', height: 'calc(100vh - 35vh)', overflowY: 'auto', overflowX: 'hidden' }}>
      <Grid container sx={{ mx: 0 }}>
        <Grid item xs={12} md={6}>
          <UseStyled.DivHeadSession>
            {t('PERSONNEL.INPUT.INFORMATION.PERSONAL_DOCUMENT')}
          </UseStyled.DivHeadSession>
          {renderFileUploadAndPreview(
            t('PERSONNEL.INPUT.INFORMATION.ID_CARD'),
            'ID_CARD'
          )}
          {renderFileUploadAndPreview(
            t('PERSONNEL.INPUT.INFORMATION.HOUSE_REGISTRATION'),
            'HOUSE_REGISTRATION'
          )}
          <Box mt={3}>
            <Typography> {t('PERSONNEL.INPUT.INFORMATION.SIGNATURE')}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, py: 1, overflowX: 'auto' }}>
              {!setAttachments_cache && (
                <Box sx={{ display: 'flex', pl: 2, }}>
                  <Button
                    onClick={() => {
                      setTabSignature('DRAW')
                      const canvases = document.getElementsByTagName('canvas')
                      Array.from(canvases).forEach(c => {
                        c.style.removeProperty('width')
                        c.style.removeProperty('height')
                      })
                    }}
                    disabled={!!uploadSignatureAttachments.base64}
                    sx={{
                      px: 0,
                      mx: 1.5,
                      pb: 0,
                      borderRadius: 0,
                      color: '#29302e',
                      borderBottom:
                        tabSignature === 'DRAW'
                          ? `3px solid ${colors.themeSecondColor}`
                          : 'none'
                    }}
                  >
                    {t('PERSONNEL.DOCUMENT.DROW_SIGNATURE')}
                  </Button>
                  <Button
                    onClick={() => setTabSignature('UPLOAD')}
                    disabled={!!signatureAttachments.base64}
                    sx={{
                      px: 0,
                      mx: 1.5,
                      pb: 0,
                      color: '#29302e',
                      borderRadius: 0,
                      borderBottom:
                        tabSignature === 'UPLOAD'
                          ? `3px solid ${colors.themeSecondColor}`
                          : 'none'
                    }}
                  >
                    {t('PERSONNEL.DOCUMENT.UPLOADE')}
                  </Button>
                </Box>
              )}
            </Box>
            <Box sx={{ mt: 1 }}>
              <Box sx={{ display: tabSignature === 'DRAW' ? 'block' : 'none', position: 'relative' }}>
                {signatureAttachments.filePath && setAttachments_cache ? (
                  <Box component="img" src={signatureAttachments.filePath} alt=""
                    sx={{ width: '90%', height: 172, border: `1px solid ${colors.disabledGray}`, objectFit: 'contain', py: 2 }}
                  />
                ) : (
                  <CanvasDraw
                    imgSrc=""
                    style={{ width: '90%', height: '172px', border: `1px solid ${colors.disabledGray}` }}
                    brushRadius={2}
                    lazyRadius={2}
                    hideInterface
                    hideGrid
                    brushColor={colors.black}
                    ref={canvasRef}
                    onChange={renderCanvas}
                  />
                )}
                <Box sx={{ position: 'absolute', top: '3%', right: '11%', display: 'flex', alignItems: 'center' }}>
                  <Box
                    onClick={clearCanvas}
                    sx={{
                      width: 85,
                      px: 2,
                      py: 0.5,
                      color: colors.themeThirdColor,
                      border: `1px solid ${colors.themeThirdColor}`,
                      borderRadius: 1,
                      fontSize: 16,
                      textAlign: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    {t('PERSONNEL.BUTTON.CLEAR')}
                  </Box>
                  <WacomStatusChip
                    supported={wacom.supported}
                    ready={wacom.ready}
                    connecting={wacom.connecting}
                    onConnect={wacom.connect}
                    deviceName={wacom.deviceName}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: tabSignature === 'UPLOAD' ? 'block' : 'none', position: 'relative', width: '90%', height: 175, py: 1,
                  '.MuiFormControl-root': {
                    height: 172,
                    img: { objectFit: 'contain', height: '100%' }
                  }
                }}
              >
                <UploadImage
                  setValue={uploadNewsImageSign}
                  pathFile={
                    signatureAttachments.filePath || uploadSignatureAttachments.base64
                  }
                />
                <Box
                  onClick={clearUploadSign}
                  sx={{
                    position: 'absolute',
                    top: 15,
                    right: 8,
                    width: 85,
                    px: 2,
                    py: 0.5,
                    color: colors.themeThirdColor,
                    border: `1px solid ${colors.themeThirdColor}`,
                    borderRadius: 1,
                    fontSize: 16,
                    textAlign: 'center',
                    cursor: 'pointer'
                  }}
                >
                  {t('PERSONNEL.BUTTON.CLEAR')}
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: 24,
                    mt: 1
                  }}
                >
                  {t('USER.ALERT.FILE_SUPPORT')}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        {/* Doctor Documents */}
        <Grid item xs={12} md={6}>
          <UseStyled.DivHeadSession>
            {t('PERSONNEL.DOCUMENT.DOCUMENT_DOCTOR')}
          </UseStyled.DivHeadSession>
          {renderFileUploadAndPreview(
            t('PERSONNEL.INPUT.DOCTOR_LICENSE'),
            'DENTIST_LICENSE'
          )}
          {renderFileUploadAndPreview(
            t('PERSONNEL.INPUT.DOCTOR_COUNCIL_BOOK'),
            'DENTAL_COUNCIL_BOOK'
          )}
          {renderFileUploadAndPreview(
            t('PERSONNEL.DOCUMENT.TREAMENT_FEE_SHEET'),
            'TRETMENT_FEE_SHEET'
          )}
          {renderFileUploadAndPreview(
            t('PERSONNEL.DOCUMENT.SHIFT_SHEDULE'),
            'DOCTOR_SCHEDULE'
          )}
          {renderFileUploadAndPreview(
            t('PERSONNEL.DOCUMENT.OPERATING_SYSTEM'),
            'OPERATING_SYSTEM'
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{ mt: { sm: 5 } }}
        >
          <UseStyled.DivHeadSession>
            {t('PERSONNEL.DOCUMENT.ADDITIONAL_DOCUMENTS')}
          </UseStyled.DivHeadSession>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              {renderFileUploadAndPreview(
                t('PERSONNEL.DOCUMENT.PROMOTION'),
                'PROMOTION'
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              {renderFileUploadAndPreview(
                t('PERSONNEL.DOCUMENT.IMAGE'),
                'IMAGE'
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box >
  )
}
